
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","viewBox":"20 9 36 36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M36.916 28.975h5.723v-1.973h-5.723v-4.229h6.563v-1.992h-9.034V31H33v1.656h1.445V35h2.471v-2.344h2.639V31h-2.639v-2.025z","fill":"#00092E"}})])
          )
        }
      }
    